export default "__VITE_ASSET__110W6U4c__"